
import {
    faUser,
    faEdit,
    faBoxes,
    faArchive,
    faBusinessTime,
    faShoppingCart,
    faTruck,
    faPen
} from "@fortawesome/free-solid-svg-icons";
export const RENT_LIST = 'rentlist';
export const RENT_SUBLIST = 'rentsublist';
export const ITEM = 'item';
export const GRID = 'grid';
export const LIST = 'list';
export const CHECK_TERM = ' - ';
export const ACTION_EDIT = 'action_edit';
export const SHOW_PAYITEMS = 'show_payitems';
export const EDIT = 'edit';
export const DELETE = 'delete';
export const RENTEDIT_CUSTOMER = 'rentedit_customer';
export const BREAKLINE = 'breakline';
export const TEXT = 'text';
export const PERCENT = 'percent';
export const INPUT = 'input';
export const COLLAPSE = 'collapse';
export const TEXT_FROM_CHILDREN = 'text_from_children';
export const READONLY = 'readonly';
export const CHECKBOX = 'checkbox';
export const SPLIT = 'split';
export const INFO = 'info';
export const DATES = "dates";
export const ONLY_CART = "onlyForCart";
export const BUTTON = 'button';
export const LINK = 'link';
export const TEXTAREA = 'textarea';
export const COMPLEX = 'complex';
export const DROPDOWN = 'dropdown';
export const CALENDAR = 'calendar';
export const DATE = 'date';
export const ADD_TWO_HOURS = 2 * 60 * 60 * 1000;
export const SHOWDATES = 'showdates';
export const INDEX = 'index';
export const COMBINE = 'combine';
export const SHOWS = 'shows';
export const DUMMY_X = 'XXXXXX';
export const HEADING = 'heading';
export const STATUS = 'status';

export const RE_FIRST_WORK = 'rentedit_firstrow_work';
export const RE_SECOND_ITEM = 'rentedit_secondrow_item';
export const RE_SECOND_DATES = 'rentedit_secondrow_showdates';

export const RE_DELIVER_ADD = 'rentedit_deliveryadd';
export const RE_INVOICE_ADD = 'rentedit_invoiceadd';
export const RE_PRICES = 'rentedit_prices';


export const ECOMMERCE_BOX_ITEMS = [
    { name: 'rental', type: 'button', intl: 'ecommerce.rental', icon: faShoppingCart, onClick: "onEcommerceBoxBtn" },
    { name: 'shipping', type: 'button', intl: 'ecommerce.shipping.btn', icon: faTruck, onClick: "onShippingBtn" }
]


export const RENTAL_SEARCH_ITEMS = [
    //{ name: "rentid", intl: "ecommerce.rentalsearch", required: true, type: "text" },
    { name: "fulltext", intl: "ecommerce.rentalsearch", required: true, type: "text" },
];

export const STATUS_DATA = [
    { name: "cart", intl: "rental.status.cart", value: "cart", htmlClasses: 'rentitem-orange' },
    { name: "request", intl: "rental.status.request", value: "request", htmlClasses: 'rentitem-dark' },
    { name: "offer", intl: "rental.status.offer", value: "offer", htmlClasses: 'rentitem-red' },
    { name: "accepted", intl: "rental.status.accepted", value: "accepted", htmlClasses: 'rentitem-green' },
    { name: "archived", intl: "rental.status.archived", value: "archived", htmlClasses: 'rentitem-lila' }
];

export const RENTAL_SEARCH_DD_ITEMS = [
    {
        name: 'status', intl: "rental.status", type: "dropdown", onDDClick: "onSearchDDClk",
        data: [{ name: DUMMY_X, intl: "rental.status", value: DUMMY_X }, ...STATUS_DATA,]
    },
    {
        name: 'incharge', intl: "rental.incharge", icon: faUser, type: "dropdown", onDDClick: "onSearchDDClk", data: [
            { name: DUMMY_X, intl: "rental.incharge", value: DUMMY_X },
            { name: "Anke Hahn", value: "Anke Hahn" },
            { name: "Diana Kluge", value: "Diana Kluge" },
            { name: "Mirko Wiermann", value: "Mirko Wiermann" },
            { name: "Ricardo Brunn", value: "Ricardo Brunn" },
            { name: "Susanne Schumann", value: "Susanne Schumann" },
        ]
    }
];


export const RENTALLIST_ITEMS_ACTIONS = [
    { name: "edit", icon: faPen, action: "edit", intl: "ecommerce.edit", htmlClasses: "rentitem-btn" }
];

export const RE_COMMENT_ITEMS = [
    { name: "comment", intl: "ecommerce.comment", type: "textarea", field: 'comment', isRentel: true },
];

export const RE_NOTE_ITEMS = [
    { name: "internnote", intl: "ecommerce.internnote", type: "text", field: 'internnote', withLabel: true },
];

export const RE_PRICES_OBJ = {
    "name": "Prices",
    "tab": "ecommerce.prices",
    "intl": "ecommerce.prices",
    "field": "prices",
    "order": 1,
    data: [
        { name: 'rentalprice', "intl": "ecommerce.rentalprice", field: 'rental', type: 'text' },
        { name: 'licence', "intl": "ecommerce.licence", field: 'licence', type: 'text' },
        { name: 'breakline', type: 'breakline' },
        { name: 'shipping', "intl": "ecommerce.shipping", field: 'shipping', type: 'text' },
        { name: 'decrypt', "intl": "ecommerce.decrypt", field: 'decrypt', type: 'text' },
        { name: 'edit', "intl": "ecommerce.processing", field: 'edit', type: 'text' },
        { name: 'tax', "intl": "ecommerce.tax", field: 'tax', type: 'text' },
        { name: 'breakline', type: 'breakline' },
        { name: 'total', "intl": "ecommerce.subtotal", field: 'total', type: 'text', htmlClasses: 'rentedit_bold' },
    ],
    "type": "complex"
};


export const RE_STATUS_ITEMS = [
    { name: 'process', type: 'text', intl: "rental.process", field: 'id' },
    {
        name: 'status', intl: "rental.status", type: "text", field: 'status', checkDisplay: true,
        htmlClass: 'rentedit-end', color: 'rentedit-red',
        data: STATUS_DATA
    }
];

export const RE_TRANSPORT = 'rentedit_itemstable';

// TRANSPORT PART BEGIN
export const ANALOG = 'analog';
export const DIGITAL = 'digital';
export const TOTAL = 'total';
//export const ANALOG_TYPES = ['VIDEO','FILM','VIDEO_DIGITAL','VIRTUAL', 'VHS'];
export const DIGITAL_TYPES = ['DIGITAL'];
export const CURRENCY = '€';

export const PRICECAT_ITEMS = [
    {
        name: 'pricecat', intl: 'rental.ddpricecat', type: 'dropdown', field: 'pricecat', onClk: "onDDClick",
        data: [
            { name: 'inland', intl: 'rental.pricecat.domestic_show' },
            { name: 'price2', intl: 'rental.pricecat.small_community_cinema' },
            { name: 'science', intl: 'rental.pricecat.scientific_use' },
            { name: 'festival', intl: 'rental.pricecat.abroad_festivals' },
        ]
    }
];

export const RENTEDIT_U = "u_";
export const RENTEDIT_R = "r_";

export const PAY_ITEMS = [
    { name: 'precharge', intl: 'rental.precharge', type: 'checkbox', field: 'precharge' },
    { name: 'holdback', intl: 'rental.holdback', type: 'checkbox', field: 'holdback' },
];

export const EDITOR_ITEMS = [
    { name: 'editor', intl: 'rental.ddincharge', type: 'text' },
    {
        name: 'incharge', intl: 'rental.ddincharge', type: 'dropdown', field: 'incharge', onClk: "onDDClick",
        data: [
            { name: 'Anke Hahn', value: 'Anke Hahn' },
            { name: 'Diana Kluge', value: 'Diana Kluge' },
            { name: 'Mirko Wiermann', value: 'Mirko Wiermann' },
            { name: 'Ricardo Brunn', value: 'Ricardo Brunn' },
            { name: 'Susanne Schumann', value: 'Susanne Schumann' }
        ]
    }
];

export const NOTE_ITEMS = [
    { name: 'internalnoteLabel', intl: 'rental.internalnote', type: 'text' },
    { name: 'internalnote', intl: 'rental.internalnote', type: 'textarea', field: 'internalnote' },
    { name: 'internalnoteHelp', intl: 'rental.internalnotehelp', type: 'text' },
];

export const ACCEPT_ITEMS = [
    { name: 'acceptuntil', intl: 'rental.acceptuntil', type: 'text' },
    { name: 'acceptuntil', intl: 'rental.acceptuntil', type: 'calendar', field: 'acceptuntil' },
];

export const ITEMCHANGE_ITEMS = [
    { name: 'itemchange', intl: 'rentedit.itemchange.heading', type: 'heading' },
    { name: 'priref', intl: 'rentedit.itemId', type: 'input', field: 'priref', isSearchBtn: true }
];


export const ITEMADD_ITEMS = [
    { name: 'itemadd', intl: 'rentedit.itemadd.heading', type: 'heading' },
    { name: 'priref', intl: 'rentedit.itemId', type: 'input', field: 'priref', isSearchBtn: true }
]

export const ITEMCHANGE_BTN_ITEMS = [
    { name: 'back', intl: 'rentedit.itemchange.back', type: 'button', action: 'cancel' },
    { name: 'save', intl: 'rentedit.itemchange.save', type: 'button', action: 'save' }
];

export const SAVE = 'save';
export const CANCEL = 'cancel';
export const RE_ITEMCHANGE = 'itemchange';
export const R_LIEFNAME = 'r_liefnachname';
export const RENTID = 'rentid';


// BY NICK

export const SHOW_DATES = [
    { name: "blockedfrom", intl: "ecommerce.rent.blockedfrom", type: "date", field: 'blockedfrom', withLabel: true },
    { name: "blockedto", intl: "ecommerce.rent.blockedto", type: "date", field: 'blockedto', withLabel: true },
];

export const EDIT_PRICECATS = {
    'festival': ['nettopershow', 'proclicense', 'fixlicense']
}

export const RE_ITEM_PRICES = 'rentedit_item_prices';
export const RE_LICENSE_PRICES = 'rentedit_license_prices';
export const RE_LICENSE_DATA = [
    { name: 'licensepartner', "intl": "ecommerce.rent.licensepartner", field: 'licensepartner', type: 'text', withLabel: true },
    { name: 'licensescope', "intl": "ecommerce.rent.licensescope", field: 'licensescope', type: 'text', withLabel: true }
];
export const RE_ITEM_NOTES = [
    { name: "intnote", intl: "ecommerce.intnote", type: "text", field: 'intnote', withLabel: true },
    { name: 'breakline', type: 'breakline' },
    { name: "extnote", intl: "ecommerce.extnote", type: "text", field: 'extnote', withLabel: true },
];

export const TRANSPORT_ANALOG = [
    { name: 'transport_analog', intl: 'ecommerce.transport.analog', type: 'text' },
    {
        name: 'transportoption', intl: 'ecommerce.transport.analog', type: 'dropdown', field: 'transportoption', onClk: "onDDClick",
        data: [
            /*{ name: 'Transport SDK', value: 'Transport SDK' },
            { name: 'Transportdienstleister 1', value: 'Transportdienstleister 1'},
            { name: 'Transportdienstleister 2', value: 'Transportdienstleister 2'},
            { name: 'Transport selbst', value: 'Transport selbst'}*/
        ]
    }
];



export const INIT_INPUTS = [
    { name: 'internalnote', intl: 'rental.internalnote', type: 'textarea', field: 'internalnote' },
    { name: 'comments', intl: 'rental.comments', type: 'textarea', field: 'comments' },
    /*{name: 'base', intl: 'rental.base', type: 'text', field: 'base'},
    {name: 'licfix', intl: 'rental.licfix', type: 'text', field: 'licfix'},
    {name: 'licproc', intl: 'rental.licproc', type: 'text', field: 'licproc'},
    {name: 'cust_tr_ana', intl: 'cust_tr_ana', type: 'text', field: 'cust_tr_ana'},
    {name: 'cust_tr_digi_defa', intl: 'rental.cust_tr_digi_defa', type: 'text', field: 'cust_tr_digi_defa'},
    {name: 'cust_tr_digi_sdk', intl: 'rental.cust_tr_digi_sdk', type: 'text', field: 'cust_tr_digi_sdk'}*/
];

export const TRANSPORT_ANALOG_SET = "transportoptionset";

export const TRANSPORT_SUPPLIER = ["SDK", "DEFA"];
export const TRANSPORT_DIGITAL_INPUT = [
    { name: 'nettosdk', intl: 'rental.cust_tr_digi_defa', type: 'text', field: 'nettosdk', ref: 'cust_tr_digi_sdk' },
    { name: 'nettodefa', intl: 'rental.cust_tr_digi_defa', type: 'text', field: 'nettodefa', ref: 'cust_tr_digi_defa' }
]
export const TRANSPORT_ANALOG_INPUT = [
    { name: 'nettoana', intl: 'rental.cust_tr_ana', type: 'text', field: 'netto', ref: 'cust_tr_ana' },
    { name: 'nettodgb', intl: 'rental.cust_tr_dgb', type: 'text', field: 'netto', ref: 'cust_tr_dgb' },
    { name: 'nettodvd', intl: 'rental.cust_tr_dvd', type: 'text', field: 'netto', ref: 'cust_tr_dvd' }
]
export const TRANSPORT_DIGITAL = [
    { name: 'transport_digital', intl: 'ecommerce.transport.digital', type: 'text' },
    {
        name: 'edelivery', intl: 'ecommerce.transport.digital', type: 'dropdown', field: 'edelivery', onClk: "onDDClick",
        data: [
            { name: '0', value: '0', intl: 'ecommerce.transport.digital.hdd' },
            { name: '1', value: '1', intl: 'ecommerce.transport.digital.link' }
        ]
    }
];

export const COMMENTS_ITEMS = [
    { name: 'commentsLabel', intl: 'rental.commentslabel', type: 'text' },
    { name: 'comments', intl: 'rental.comments', type: 'textarea', field: 'comments' }
];

export const TOTAL_ITEMS = [
    {
        transport: {
            analog: [
                { name: 'netto', intl: 'ecommerce.offer.analog', type: 'text', field: 'netto' },
            ],
            digital: [
                { name: 'nettosdk', intl: 'ecommerce.offer.digital.sdk', type: 'text', field: 'nettosdk' },
                { name: 'nettodefa', intl: 'ecommerce.offer.digital.defa', type: 'text', field: 'nettodefa' }
            ]
        }
    },
    {
        total: [
            { name: 'taxedamount', intl: 'ecommerce.offer.taxedamount', type: 'text', field: 'taxedamount' },
            { name: 'tax', intl: 'ecommerce.offer.tax', type: 'text', field: 'tax' },
            { name: 'taxfreeamount', intl: 'ecommerce.offer.taxfreeamount', type: 'text', field: 'taxfreeamount' },
        ]
    },
    {
        total: [
            { name: 'netto', intl: 'ecommerce.offer.netto', type: 'text', field: 'netto' },
            { name: 'tax', intl: 'ecommerce.offer.tax', type: 'text', field: 'tax' },
            { name: 'brutto', intl: 'ecommerce.offer.brutto', type: 'text', field: 'brutto' },
        ]
    }
];

export const SHIPPING_ITEMS = [
    { name: 'id', field: 'id', intl: 'shipping.id', type: 'text' },
    { name: 'status', field: 'status', intl: 'shipping.status', type: 'text' },
    { name: 'rent_id', field: 'rent_id', intl: 'shipping.rent_id', type: 'text' },
    { name: 'filmtitle', field: 'filmtitle', intl: 'shipping.filmtitle', type: 'text' }
]


//SHIPPING BEGIN
export const SHIPPING_LIST = 'shippinglist';
//Status: status:{'none'':'Kein Status','new':'Neu','inprocess':'in Bearbeitung','send':'beauftragt','undchecked':'ungeprüft','checked':'geprüft','overdue':'überfällig'}
export const SHIPPING_STATUS_DATA = [
    { name: DUMMY_X, intl: "re.shipping.status", value: DUMMY_X },
    { name: "none", intl: "re.shipping.status.none", value: "none" },
    { name: "new", intl: "re.shipping.status.new", value: "new", color: "green", htmlClasses: "shippingitem-green" },
    { name: "inprocess", intl: "re.shipping.status.inprocess", value: "inprocess", color: "blue", htmlClasses: "shippingitem-blue" },
    { name: "send", intl: "re.shipping.status.send", value: "send", color: "light_blue", htmlClasses: "shippingitem-lightblue" },
    { name: "unchecked", intl: "re.shipping.status.unchecked", value: "unchecked", color: "yellow", htmlClasses: "shippingitem-yellow" },
    { name: "checked", intl: "re.shipping.status.checked", value: "checked", color: "dark_green", htmlClasses: "shippingitem-darkgreen" },
    { name: "overdue", intl: "re.shipping.status.overdue", value: "overdue", color: "dark_yellow", htmlClasses: "shippingitem-orange" },
];

export const E_SHIPPING_SEARCH_DD_ITEMS = [
    {
        name: 'status', intl: "re.shipping.status", type: "dropdown", onDDClick: "onSearchDDClk", icon: faBusinessTime,
        data: [...SHIPPING_STATUS_DATA]
    },
    {
        name: 'supplier', intl: "re.shipping.supplier", icon: faBoxes, type: "dropdown", onDDClick: "onSearchDDClk", data: [
            { name: DUMMY_X, intl: "re.shipping.supplier", value: DUMMY_X },
            { name: "SDK", value: "SDK" },
            { name: "DEFA", value: "DEFA" },
        ]
    },
    {
        name: 'material', intl: "re.shipping.material", icon: faArchive, type: "dropdown", onDDClick: "onSearchDDClk", data: [
            { name: DUMMY_X, intl: "re.shipping.material", value: DUMMY_X },
            { name: "8mm", value: "8mm" },
            { name: "16mm", value: "16mm" },
            { name: "35mm", value: "35mm" },
            { name: "70mm", value: "70mm" },
            { name: "Access File", value: "Access File" },
            { name: "Blu-ray", value: "Blu-ray" },
            { name: "DCP", value: "DCP" },
            { name: "DigiBeta", value: "DigiBeta" },
            { name: "DVD", value: "DVD" },
            { name: "Lizenz", value: "Lizenz" },
        ]
    },
    { name: 'shownostatus', intl: 're.shipping.noshipping', type: 'checkbox', field: 'shownostatus' },
];

export const E_SHIPPING_SEARCH_ITEMS = [
    { name: "fulltext", intl: "ecommerce.shippingsearch", required: true, type: "text" },
];

export const SHOW_PAGES = 3;
export const LIMIT = 20;
export const DESC = 'desc';
export const ASC = 'asc';

export const SHIPPING_CB_ITEMS = [
    { name: 'name', intl: 're.shipping.noshipping', type: 'checkbox', field: 'status', value: 'shownostatus' },
];
//SHIPPING END

